const maskPhone = (v) => {
  if (v) {
    let pure = v?.replace(/\D/g, '');
    if (pure.length > 10) {
      return maskCell(pure);
    } else {
      return maskFixed(pure);
    }
  }
};

const maskCell = (pure) => {
  if (pure.length > 7) {
    pure = pure.slice(0, 7) + '-' + pure.slice(7);
  }
  if (pure.length > 2) {
    pure = pure.slice(0, 2) + ') ' + pure.slice(2);
  }
  if (pure.length > 0) {
    pure = `(${pure}`;
  }
  return pure.slice(0, 15);
};
const maskFixed = (pure) => {
  if (pure.length > 6) {
    pure = pure.slice(0, 6) + ' ' + pure.slice(6);
  }
  if (pure.length > 2) {
    pure = pure.slice(0, 2) + ') ' + pure.slice(2);
  }
  if (pure.length > 0) {
    pure = `(${pure}`;
  }
  return pure.slice(0, 15);
};

const maskCpfCnpj = (v) => {
  let pure = v.replace(/\D/g, '');
  if (pure.length <= 11) {
    return maskCFP(pure);
  } else {
    return maskCNPJ(pure);
  }
};

const maskCFP = (pure) => {
  if (pure.length > 3) {
    pure = pure.slice(0, 3) + '.' + pure.slice(3);
  }
  if (pure.length > 7) {
    pure = pure.slice(0, 7) + '.' + pure.slice(7);
  }
  if (pure.length > 11) {
    pure = pure.slice(0, 11) + '-' + pure.slice(11);
  }
  return pure.slice(0, 14);
};

const maskCNPJ = (pure) => {
  if (pure.length > 2) {
    pure = pure.slice(0, 2) + '.' + pure.slice(2);
  }
  if (pure.length > 6) {
    pure = pure.slice(0, 6) + '.' + pure.slice(6);
  }
  if (pure.length > 10) {
    pure = pure.slice(0, 10) + '/' + pure.slice(10);
  }
  if (pure.length > 15) {
    pure = pure.slice(0, 15) + '-' + pure.slice(15);
  }
  return pure.slice(0, 18);
};

const maskCard = (text, setCardNumber, length = 16) => {
  text = text.replace(/\D/g, '');

  let numberWithoutSpaces;
  if (text.length <= length) {
    numberWithoutSpaces = text;
    text = text.match(/.{1,4}/g);
    setCardNumber(text?.join(' ')?.trim() || '');
  }

  return numberWithoutSpaces;
};

const maskDate = (date, setDate) => {
  date = date.replace(/\D/g, '');

  if (date.length <= 4) {
    date = date.match(/.{1,2}/g);
    return setDate(date?.join('/')?.trim() || '');
  }
};

const maskNumber = (number, maxDigits = 1, setNumber) => {
  number = number.replace(/\D/g, '');

  if (number.length <= maxDigits) {
    const trimNumber = number?.trim();
    if (setNumber) {
      return setNumber(trimNumber);
    }

    return trimNumber;
  }
};

const maskName = (name, setName, maxDigits = 60) => {
  const valid = /^([a-zA-Z ]|[à-ú]|[À-Ú])+$/.test(name);

  if ((valid && name.length <= maxDigits) || name === '') setName(name);
};

const maskZip = (v) => {
  let pure = v?.replace(/\D/g, '');
  if (pure.length > 5) {
    pure = pure.slice(0, 5) + '-' + pure.slice(5);
  }
  return pure.slice(0, 9);
};

const maskEmail = (email) => {
  let maskedEmail = email.split('@');

  let tamanho = maskedEmail[0].split('');
  let toMask = maskedEmail[0].slice(1, tamanho.length - 1);

  let newStr = toMask.replace(/[a-z0-9]/gi, '*');

  let lastCharacter = tamanho.length - 1;

  return tamanho[0] + newStr + tamanho[lastCharacter] + '@' + maskedEmail[1];
};

const maskSocialMedia = (value) => {
  if (value) {
    return '@' + value.replace(/[^a-zA-Z0-9_.-]/g, '');
  }
};

export {
  maskPhone,
  maskCpfCnpj,
  maskCard,
  maskDate,
  maskNumber,
  maskName,
  maskZip,
  maskEmail,
  maskSocialMedia,
};
